// extracted by mini-css-extract-plugin
export var article_container = "featuredArticle-module--article_container--4312a";
export var bar = "featuredArticle-module--bar--7045e";
export var img_wrapper = "featuredArticle-module--img_wrapper--972f9";
export var triangle_wrapper_left = "featuredArticle-module--triangle_wrapper_left--3975f";
export var triangle_wrapper_right = "featuredArticle-module--triangle_wrapper_right--aa905";